import { Convert } from '@itus/ui.common'

export const probabilityLifeCycleState = {
  notDefined: 'notdefined',
  new: 'new',
  edit: null,
  removed: 'removed'
}
const validStates = [
  probabilityLifeCycleState.notDefined,
  probabilityLifeCycleState.new,
  probabilityLifeCycleState.edit,
  probabilityLifeCycleState.removed
]

class WeibullDistributionParameters {
  constructor(data) {
    data = data || {}
    this.type = Convert.toString(data.type, 'cdf')
    this.shape = Convert.toFloat(data.shape, null)
    this.scale = Convert.toString(data.scale, null)
  }
}

class NoDistributionParameters {
  constructor(data) {
    data = data || {}
    this.type = Convert.toString(data.type, 'none')
    this.scale = Convert.toString(data.scale, null)
  }
}

export class ProbabilityModel {
  constructor(data) {
    data = data || {}
    this.id = Convert.toString(data.id, null)
    this.assetId = Convert.toString(data.assetId, null)
    this.twinId = Convert.toString(data.twinId, null)
    this.failureModeId = Convert.toString(data.failureModeId, null)
    this.value = Convert.toInteger(data.value, null)
    this.riskAnalysisValue = Convert.toInteger(data.riskAnalysisValue, null)
    this.failureDistribution = Convert.toString(data.failureDistribution, 'none')
    if (this.failureDistribution === 'weibull') {
      this.failureDistributionParameters = new WeibullDistributionParameters(data.failureDistributionParameters)
    } else {
      this.failureDistributionParameters = new NoDistributionParameters(data.failureDistributionParameters)
    }

    this.library = data.library
    this.lifeCycleState = Convert.toString(data.lifeCycleState, null)
    if (!validStates.includes(this.lifeCycleState)) {
      throw new Error('invalid life cycle state for probability: ' + this.lifeCycleState)
    }
  }
}
export default { ProbabilityModel, WeibullDistributionParameters }
